module.exports = __webpack_public_path__ + "img/horse.be5030ca.webp";